// The message of a failure. It is a leaf with no import, so a lab page
// reads it without the import chain of `net/api.ts`, which re-exports it.

/**
 * The message of a failure, whichever shape it arrived in. Every screen
 * that prints a failed call reads it here.
 *
 * An `Error` gives its own message: the server's sentence off an ApiError,
 * and the runtime's sentence off the `TypeError` a broken `fetch` throws.
 * `String(err)` is the fallback for a thrown value that is no error at all.
 *
 * The class name never reaches the screen (R1048). `String` on an `Error`
 * gives "Error: the network went", and "Error:" states only that a program
 * threw. A reader of a failed line wants what went wrong.
 */
export function messageOf(err: unknown): string {
  return err instanceof Error ? err.message : String(err);
}
